import { Separator } from '@/components/ui';

type TProps = {
  title: string;
  description?: string;
}

const HeaderPage = ({ title, description }: TProps) => (
  <div className='flex flex-col space-y-4'>
    <div>
      <h3 className='text-lg font-medium'>
        {title}
      </h3>
      {
        description &&
        <p className='text-sm text-muted-foreground'>
          {description}
        </p>
      }
    </div>
    <Separator />
  </div>
);

export default HeaderPage;
